export default "__VITE_ASSET__DXWLzDJ9__"